import axios from "axios"
import get from "lodash/get"
import URITemplate from "urijs/src/URITemplate"
import {
  GET_SAME_WASTE_STREAM_ELIGIBILITY_PENDING,
  GET_SAME_WASTE_STREAM_ELIGIBILITY_FULFILLED,
  GET_SAME_WASTE_STREAM_ELIGIBILITY_FAILED,
  GET_NEW_WASTE_STREAM_ELIGIBILITY_FAILED,
  GET_NEW_WASTE_STREAM_ELIGIBILITY_FULFILLED,
  GET_NEW_WASTE_STREAM_ELIGIBILITY_PENDING,
} from "constants-lib/actionTypes"
import { getTokenAction } from "actions-lib/getToken"
import { urls } from "utils-lib/builds"
import { NO, YES } from "constants-lib/common"
import { MOCK_SERVICE_CHANGE_INFORMATION } from "utils-lib/mocks"
import { getWindow } from "utils-lib/getWindow"

const ssrWindow = getWindow()

export const pendingNewWastestreamAC = () => ({
  type: GET_NEW_WASTE_STREAM_ELIGIBILITY_PENDING,
})

export const failedNewWastestreamAC = () => ({
  type: GET_NEW_WASTE_STREAM_ELIGIBILITY_FAILED,
})

export const fulfilledNewWastestreamAC = (data) => ({
  type: GET_NEW_WASTE_STREAM_ELIGIBILITY_FULFILLED,
  payload: data,
})

export const pendingSameWastestreamAC = () => ({
  type: GET_SAME_WASTE_STREAM_ELIGIBILITY_PENDING,
})

export const failedSameWastestreamAC = () => ({
  type: GET_SAME_WASTE_STREAM_ELIGIBILITY_FAILED,
})

export const fulfilledSameWastestreamAC = (data) => ({
  type: GET_SAME_WASTE_STREAM_ELIGIBILITY_FULFILLED,
  payload: data,
})

export const getServiceChangeEligibility =
  ({ customerId, isAddWasteStream, isChangeService }) =>
  (dispatch, getState) => {
    const api = `SERVICE_CHANGE_ELIGIBILITY`
    const template = URITemplate(urls.url[api])
    const state = getState()
    const locale = get(state, `siteLanguage.language`, ``)

    let mockJsonFile
    if (isAddWasteStream === YES)
      mockJsonFile = `${ssrWindow.origin}/mock/add-new-wastestream-service-change-eligibility-response.json`
    else if (isChangeService === YES)
      mockJsonFile = `${ssrWindow.origin}/mock/add-same-wastestream-service-change-eligibility-response.json`

    const url = MOCK_SERVICE_CHANGE_INFORMATION
      ? mockJsonFile
      : template.expand({
          customerId,
          userId: get(state, `userAccount.userDetails.userId`, ``),
          lang: locale,
        })

    const config = {
      headers: {},
    }

    return getTokenAction(dispatch, getState).then(async (res) => {
      config.headers.oktaToken = res.accessToken
      config.headers.apiKey = get(urls, `apiKey.USER[${api}]`, ``)

      const fullURL = `${url}&pauseService=${NO}&addWasteStream=${isAddWasteStream}&changeService=${isChangeService}`

      return getServiceChangeEligibilityHelper(
        fullURL,
        config,
        isAddWasteStream,
        isChangeService,
        dispatch,
      )
    })
  }

export const getServiceChangeEligibilityHelper = (
  url,
  config,
  isAddWasteStream,
  isChangeService,
  dispatch,
) => {
  if (isAddWasteStream === YES) {
    dispatch(pendingNewWastestreamAC())
  }
  if (isChangeService === YES) {
    dispatch(pendingSameWastestreamAC())
  }

  return axios
    .get(url, config)
    .then((response) => {
      if (isAddWasteStream === YES) {
        dispatch(fulfilledNewWastestreamAC(get(response, `data.data`, {})))
      }
      if (isChangeService === YES) {
        dispatch(fulfilledSameWastestreamAC(get(response, `data.data`, {})))
      }
      return response.data
    })
    .catch((error) => {
      if (isAddWasteStream === YES) {
        dispatch(failedNewWastestreamAC())
      }
      if (isChangeService === YES) {
        dispatch(failedSameWastestreamAC())
      }
      return error
    })
}
